import { render, staticRenderFns } from "./ViewSelectedPPWFiles.vue?vue&type=template&id=4a772196&scoped=true"
import script from "./ViewSelectedPPWFiles.vue?vue&type=script&lang=js"
export * from "./ViewSelectedPPWFiles.vue?vue&type=script&lang=js"
import style0 from "./ViewSelectedPPWFiles.vue?vue&type=style&index=0&id=4a772196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a772196",
  null
  
)

export default component.exports